import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

type AiSuggestionsArchivePreviewVariables = {
	startDate: Date;
	endDate: Date;
	impersonationContext?: Api.IImpersonationContext;
};

export type AiSuggestionsArchivePreview = Api.IPagedCollection<Api.IContentCalendarSuggestion>;

export const useAiSuggestionsArchivePreviewMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (preview: AiSuggestionsArchivePreview, variables: AiSuggestionsArchivePreviewVariables) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ startDate, endDate, impersonationContext }: AiSuggestionsArchivePreviewVariables) => {
			return userSession.webServiceHelper.callAsync<AiSuggestionsArchivePreview>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'ContentCalendarSuggestion/ai/archive/preview',
					queryParams: {
						startDate: startDate.toISOString(),
						endDate: endDate.toISOString(),
					},
					impersonationContext,
				}),
				'GET',
				null
			);
		},
		onError,
		onSuccess,
	});
};

export const getAiSuggestionsArchivePreviewCount = (preview?: AiSuggestionsArchivePreview) =>
	preview?.totalCount ?? preview?.values?.length ?? 0;
